import { createContext } from "react";
import { HMIView } from "./HMIContextInterfaces";
import {
    getCurrentFailureType,
    getCurrentArea,
    getCurrentFailureCode,
    getCurrentFunctionalLocation,
    getCurrentFailureDetailsStep,
    getCurrentNotes,
    getCurrentOperator,
    getHMIDisplayUnit,
} from "../../utilities/storageUtilities";
import { ShiftOptionsEnum } from "components/ShiftDropdown/ShiftDropdown.view";
import { ViewOptionsEnum } from "components/ViewDropdown/ViewDropdown.view";

const currentOperator = getCurrentOperator();
const currentFailureDetailStep = getCurrentFailureDetailsStep();
const currentFailureType = getCurrentFailureType();
const currentArea = getCurrentArea();
const currentFunctionalLocation = getCurrentFunctionalLocation();
const currentFailureCode = getCurrentFailureCode();
const currentNotes = getCurrentNotes();
const currentDisplayUnit = getHMIDisplayUnit();

export const initialState: HMIView = {
    view: ViewOptionsEnum?.summary,
    handleView: () => {},
    shift: ShiftOptionsEnum.current,
    handleShift: () => {},
    displayUnit: currentDisplayUnit ?? "minutes",
    handleDisplayUnit: () => {},
    operator: currentOperator,
    handleOperator: () => {},
    failureType: currentFailureType ?? undefined,
    handleFailureTypeChange: () => {},
    area: currentArea ?? undefined,
    handleArea: () => {},
    functionalLocation: currentFunctionalLocation ?? undefined,
    handleFunctionalLocation: () => {},
    failureCode: currentFailureCode ?? undefined,
    handleFailureCode: () => {},
    notes: currentNotes ?? "",
    handleNotes: () => {},
    failureDetailsStep: currentFailureDetailStep ?? 1,
    handlePreviousFailureDetailsStep: () => {},
    handleNextFailureDetailsStep: () => {},
    handleSetFailureDetailStep: () => {},
    resetEditingSelections: () => {},
    resetHMIContextProvider: () => {},
};

export const HMIContext = createContext(initialState);
